/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { analyticsAdditionalQuestionsAnalytics } from '../../axios/analyticsAdditionalQuestionsAnalytics'
import type {
	AnalyticsAdditionalQuestionsAnalyticsError,
	AnalyticsAdditionalQuestionsAnalyticsPathParams,
	AnalyticsAdditionalQuestionsAnalyticsQueryParams,
	AnalyticsAdditionalQuestionsAnalyticsResponse,
} from '../../types/AnalyticsAdditionalQuestionsAnalytics'

export const analyticsAdditionalQuestionsAnalyticsQueryKey = (
	campaign: AnalyticsAdditionalQuestionsAnalyticsPathParams['campaign'],
	params?: AnalyticsAdditionalQuestionsAnalyticsQueryParams,
) => [
	{ url: '/campaigns/:campaign/additional-questions-analytics', params: { campaign } },
	...(params ? [params] : []),
] as const

export type AnalyticsAdditionalQuestionsAnalyticsQueryKey = ReturnType<
	typeof analyticsAdditionalQuestionsAnalyticsQueryKey
>

/** @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::additionalQuestionsAnalytics */
export function analyticsAdditionalQuestionsAnalyticsQueryOptions(
	campaign: AnalyticsAdditionalQuestionsAnalyticsPathParams['campaign'],
	params?: AnalyticsAdditionalQuestionsAnalyticsQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		AnalyticsAdditionalQuestionsAnalyticsResponse,
		AxiosError<AnalyticsAdditionalQuestionsAnalyticsError>,
		AnalyticsAdditionalQuestionsAnalyticsResponse,
		AnalyticsAdditionalQuestionsAnalyticsQueryKey
	>({
		queryKey: analyticsAdditionalQuestionsAnalyticsQueryKey(campaign, params),
		queryFn: ({ signal }) =>
			analyticsAdditionalQuestionsAnalytics(campaign, params, { signal, ...config }).then(res => res.data),
		enabled: !!campaign,
	})
}

/** @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::additionalQuestionsAnalytics */
export function useAnalyticsAdditionalQuestionsAnalytics<TSelectData = AnalyticsAdditionalQuestionsAnalyticsResponse>(
	campaign: AnalyticsAdditionalQuestionsAnalyticsPathParams['campaign'],
	params?: AnalyticsAdditionalQuestionsAnalyticsQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					AnalyticsAdditionalQuestionsAnalyticsResponse,
					AxiosError<AnalyticsAdditionalQuestionsAnalyticsError>,
					TSelectData,
					AnalyticsAdditionalQuestionsAnalyticsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<AnalyticsAdditionalQuestionsAnalyticsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...analyticsAdditionalQuestionsAnalyticsQueryOptions(campaign, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::additionalQuestionsAnalytics */
export function useAnalyticsAdditionalQuestionsAnalyticsSuspense<
	TSelectData = AnalyticsAdditionalQuestionsAnalyticsResponse,
>(
	campaign: AnalyticsAdditionalQuestionsAnalyticsPathParams['campaign'],
	params?: AnalyticsAdditionalQuestionsAnalyticsQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					AnalyticsAdditionalQuestionsAnalyticsResponse,
					AxiosError<AnalyticsAdditionalQuestionsAnalyticsError>,
					TSelectData,
					AnalyticsAdditionalQuestionsAnalyticsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<AnalyticsAdditionalQuestionsAnalyticsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...analyticsAdditionalQuestionsAnalyticsQueryOptions(campaign, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
